import styled from "styled-components";

export const ActionsGrid = styled.div`
	display: flex;
	gap: 9px;
	flex-wrap: wrap;
	margin-top: 16px;

	@media (max-width: 620px) {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}
`;

export const ActionButton = styled.button<{
	isPrimary?: boolean;
	isActive?: boolean;
}>`
	border-radius: 100px;
	padding: 9px 14px;
	font-size: 11px;
	font-weight: 700;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 7px;
	cursor: pointer;
	font-family: "NotoSans-Bold", sans-serif;
	transition: background-color 0.2s ease, border-color 0.2s ease;

	&:disabled {
		opacity: 0.65;
		cursor: wait;
	}

	${({ isPrimary, isActive }) => {
		if (isPrimary) {
			return `
				background: #009973;
				color: #ffffff;
				border: 1px solid #009973;
				&:hover {
					background: #008060;
					border-color: #008060;
				}
			`;
		}
		if (isActive) {
			return `
				background: rgba(0, 153, 115, 0.1);
				border: 1px solid #009973;
				color: #ffffff;
				&:hover {
					background: rgba(0, 153, 115, 0.15);
				}
			`;
		}
		return `
			background: #ffffff10;
			border: 1px solid #ffffff20;
			color: #ffffff;
			&:hover {
				background: #ffffff15;
				border-color: #ffffff30
			}
		`;
	}}
`;
